import { IParentPlayerGroup, IParentPlayerProfile } from '../../../lib/types';

export interface IFlatPlayer {
  displayName: string;
  profile: IParentPlayerProfile;
}

// Server groups by normalized name; the dashboard renders one card per profile,
// so flatten while keeping each group's displayName.
export const flattenGroups = (groups: IParentPlayerGroup[]): IFlatPlayer[] =>
  groups.flatMap((g) => g.players.map((profile) => ({ displayName: g.displayName, profile })));

export const hasCurrentYearAssessment = (profile: IParentPlayerProfile, currentYear: number) =>
  profile.assessments.some((row) => row.year === currentYear);

// Players with a current-year assessment first; then alphabetical by displayName.
export const sortPlayers = (players: IFlatPlayer[], currentYear: number): IFlatPlayer[] =>
  [...players].sort((a, b) => {
    const aActive = hasCurrentYearAssessment(a.profile, currentYear);
    const bActive = hasCurrentYearAssessment(b.profile, currentYear);
    if (aActive !== bActive) return aActive ? -1 : 1;
    return a.displayName.localeCompare(b.displayName);
  });
